import { useMutation, useQuery } from "@tanstack/react-query";
import { getAuthData } from "../../helper/getAuthData";
import AxiosConfig from "../../configurations/axiosConfig";

const endpoint = {
    cartItems: "cart-items",
}

export const useAddProductToCart = () => useMutation({
    mutationKey: ["addProductToCart"],
    mutationFn: async ({ ProductID, Quantity }) => {
        const authData = getAuthData();
        const payload = {
            ComID: authData?.ComID,
            Flag: "I",
            UserID: authData?.UserID,
            AuthCode: authData?.AuthCode,
            ProductID: ProductID,
            Quantity: Quantity
        }
        const response = await AxiosConfig.post(`${endpoint.cartItems}`, payload);
        return response?.data;
    }
});

export const useUpdateCartProduct = () => useMutation({
    mutationKey: ["updateCartProduct"],
    mutationFn: async ({ CartID, Quantity }) => {
        const authData = getAuthData();
        const payload = {
            ComID: authData?.ComID,
            Flag: "U",
            UserID: authData?.UserID,
            AuthCode: authData?.AuthCode,
            CartID: CartID,
            Quantity: Quantity
        }
        const response = await AxiosConfig.post(`${endpoint.cartItems}`, payload);
        return response?.data;
    }
})

export const useGetAllCartProducts = () => useQuery({
    queryKey: ["getAllCartProducts"],
    queryFn: async () => {
        const authData = getAuthData();
        const payload = {
            ComID: authData?.ComID,
            Flag: "S",
            UserID: authData?.UserID,
            AuthCode: authData?.AuthCode,
        }
        const response = await AxiosConfig.post(`${endpoint.cartItems}`, payload);
        return response?.data?.CartItemList || [];
    },
    enabled: !!getAuthData()?.AuthCode,
});

export const useRemoveCartProduct = () => useMutation({
    mutationKey: ["removeCartProduct"],
    mutationFn: async ({ CartID }) => {
        const authData = getAuthData();
        const payload = {
            ComID: authData?.ComID,
            Flag: "R",
            UserID: authData?.UserID,
            AuthCode: authData?.AuthCode,
            CartID: CartID,
        }
        const response = await AxiosConfig.post(`${endpoint.cartItems}`, payload);
        return response?.data;
    }
});

export const useRemoveAllCartItems = () => useMutation({
    mutationKey: ["removeAllCartItems"],
    mutationFn: async () => {
        const authData = getAuthData();
        const payload = {
            ComID: authData?.ComID,
            Flag: "RA",
            UserID: authData?.UserID,
            AuthCode: authData?.AuthCode,
        }
        const response = await AxiosConfig.post(`${endpoint.cartItems}`, payload);
        return response?.data;
    }
});